import type { MembersQueryParams } from '../api/members.service';

export const MEMBERS_KEYS = {
  all: ['members'] as const,
  byOrg: (orgId: string) => ['members', orgId] as const,
  list: (orgId: string, params: MembersQueryParams) => ['members', orgId, 'list', params] as const,
};

export const INVITATIONS_KEYS = {
  byOrg: (orgId: string) => ['invitations', orgId] as const,
  list: (orgId: string, params?: object) => ['invitations', orgId, 'list', params] as const,
};
